import React from 'react';

const ComingSoon = () => {
  return (
    <div className="d-flex justify-content-center align-items-center h-100  text-black">
      <div className="text-center">
        <h1 className="display-1">Coming Soon</h1>
        <p className="lead">We're working hard to bring something amazing. Stay tuned!</p>
        <div className="spinner-border text-dark" role="status">
          <span className="sr-only"></span>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
